<template>
  <section class="pins">
    <div class="pins-wrap">

    <div class="pins-header">

      <h2 class="timeline-title">{{title}}</h2>
        <div class="pins-header-wrap">

            <!-- <div class="map-button map-button_rainbow" @click="changeState('sports')">
              <p>Категории</p>
            </div> -->
            <!-- <img class="search-icon" v-if="!open_search" @click="open_search = true" src="@/assets/images/icon_search-b.svg" width="22px" /> -->
        </div>
      </div>
      <PinAdd v-if="adder" />
      <PinSettings 
        v-if="settings" 
        :settings="settings" 
        @close="settings = null" 
        @unwantedPin="unwantedPin"
      />
      <Info 
        @click.native="openAction()"
        :content="'Привет, ты зашел на этот сервис, тебе понравилась задумка и ты хочешь увидеть рабочий сервис для экстремальных видов спорта?'" 
        :description="'Создатель wildwood Алексей Чернов'" 
        :button="{text: 'Да'}"
      />
      <div class="pins-body" v-if="loading">
        <PinPseudo v-for="(pin, index) in 15" :key="index" />
      </div>
      <div class="pins-body" v-else>
        <Pin 
          v-for="pin in pins" 
          :key="pin.id" 
          :pin="pin"
          @setSettings="setSettings"
          @mouseenter.native="viewPin(pin)"
        />
      </div>
      <div class="loader-more" v-show="loading_more">
        <Loader :color="'black'" />
      </div>
      <Users />
    </div>

  </section>
</template>
<script>
import Pin from './Pin.vue'
import PinAdd from './Add.vue'
// import termsAction from "@/data/main/termsAction"
import greatAgain from "@/data/main/greatAgain"

export default {
  name: 'Pins',
  data () {
    return {
        com_message: '',
        comments: false,
        settings: null,
        views: []
    }
  },
  props: {
    pins: {
      type: Array,
      required: false
    },
    adder: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: 'Лента'
    },
    loading: {
      type: Boolean,
      required: false
    },
    loading_more: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Pin,
    PinAdd,
    PinPseudo: () => import('./PinPseudo.vue'),
    PinSettings: () => import('@/components/Modals/Settings.vue'),
    Users: () => import('./Users.vue'),
    Loader: () => import('@/components/UI/Loader.vue'),
    Info: () => import('@/components/UI/Info'),
  },
  computed: {
    getUser() {
      return this.$store.getters.getAuthUser
    }
  },
  methods: {
    openAction() {
      this.$store.dispatch('setModal', greatAgain )
    },
    unwantedPin(data) {
      this.$axios.post(`/api/pins/unwanted`, data)
      .then(res => {
        this.$store.dispatch('hidePin', res.data)
        this.$store.dispatch('addNotification', {message: 'Этот пост больше не будет показываться в вашей ленте'})
      })
      this.settings = null
    },
    setSettings(data) {
      this.settings = data
    },
    setUsers(data) {
      this.users = data
    },
    viewPin(pin) {
      let finded = this.views.find(view => view === pin.id);
      if (!finded) {
        this.$store.dispatch('sendPinView', {id: pin.id})
        this.views.push(pin.id)
      }
    }
  }
}; 
</script>
<style lang="stylus">
.pins
  width 100%
  height 100%
  display flex
  flex-direction column
  align-items center
  padding 40px 0
  overflow-y auto
  +to-width(640px)
    padding-bottom 100px
  +to-width(540px)
    background-color #f9f9f9
  
  &-wrap
    max-width 690px
    padding 0 20px
    width 100%
    min-height 100vh
    +to-width(540px)
      padding 0

  .info
    +to-width(540px)
      border none

  &-header
    display flex
    justify-content space-between
    padding-bottom 20px
    &-wrap
      display flex
    +to-width(540px)
      padding 0 25px
      padding-bottom 20px

</style>
